import React from "react";
import { Navigate } from "react-router-dom";
import { PERMISSIONS } from "../constants/permissions";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import AuthLockScreen from "../pages/Authentication/AuthLockScreen";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

// Pages Component
import Chat from "../pages/Chat/Chat";

//Utility
import Maintenance from "../pages/Utility/Maintenance";
import CommingSoon from "../pages/Utility/CommingSoon";
import Error404 from "../pages/Utility/Error404";
import Error500 from "../pages/Utility/Error500";

// Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login";
import Register1 from "../pages/AuthenticationInner/Register";
import ForgetPwd1 from "../pages/AuthenticationInner/ForgetPassword";
import RoomType from "../pages/RoomType/RoomType";
import AddRoomType from "../pages/RoomType/AddRoomType";
import HouseType from "../pages/HouseType/HouseType";
import AddHouseType from "../pages/HouseType/AddHouseType";
import BedType from "../pages/BedType/BedType";
import AddBedType from "../pages/BedType/AddBedType";
import PersonCapacity from "../pages/PersonCapacity/PersonCapacity";
import Bed from "../pages/Bed/Bed";
import Bathroom from "../pages/Bathroom/Bathroom";
import BathroomType from "../pages/BathroomType/BathroomType";
import AddBathroomType from "../pages/BathroomType/AddBathroomType";
import BedRoom from "../pages/Bedroom/Bedroom";
import Safety from "../pages/Safety/Safety";
import AddSafety from "../pages/Safety/AddSafety";
import Space from "../pages/Space/Space";
import AddSpace from "../pages/Space/AddSpace";
import User from "../pages/User/User";
import VerifyUser from "../pages/User/VerifyUser";
import ManageAdminRoles from "../pages/ManageAdmins/ManageAdminRoles/ManageAdminRoles";
import SiteSettings from "../pages/Site/SiteSettings";
import SiteConfigurations from "../pages/Site/SiteConfigurations";
import Essential from "../pages/Essential/Essential";
import AddEssential from "../pages/Essential/AddEssential";
import HouseRules from "../pages/HouseRules/HouseRules";
import AddHouseRules from "../pages/HouseRules/AddHouseRules";
import MinNights from "../pages/MinNights/MinNights";
import MaxNights from "../pages/MaxNights/MaxNights";
import Property from "../pages/Property/Property";
import InProgressProperties from "../pages/Property/InProgressProperties";
import CreateMultiUnitListing from "../pages/Property/CreateMultiUnitListing";
import BulkCreateListings from "../pages/Property/BulkCreateListings";
import ListingsRequests from "../pages/ListingsRequests/ListingsRequests";
import EditRequests from "../pages/EditRequests/EditRequests";
import DeleteRequests from "../pages/DeleteRequests/DeleteRequests";
import ListingDeleteRequests from "../pages/ListingDeleteRequests/ListingDeleteRequests";
import ProfileView from "../pages/ProfileView/ProfileView";
import ManageAdminUsers from "../pages/ManageAdmins/ManageAdminUsers/ManageAdminUsers";
import CouponsList from "../pages/Coupons/CouponsList";
import TicketsList from "../pages/Tickets/TicketsList";
import CancelationPolicy from "../pages/CancelationPolicy/CancelationPolicy";
import AddCancelationPolicy from "../pages/CancelationPolicy/AddCancelationPolicy";
import Location from "../pages/PopularLocation/Location";
import AddLocation from "../pages/PopularLocation/AddLocation";
import BannerImage from "../pages/Banner/BannerImage";
import ReviewsManagement from "../pages/ReviewsManagement/ReviewsManagement";
import ServiceFee from "../pages/ServiceFee/ServiceFee";
import Reservation from "../pages/Reservation/Reservation";
import ReservationView from "../pages/Reservation/RervationView";
import ReservationCancel from "../pages/Reservation/ReservationCancel";
import ManageReservation from "../pages/Reservation/ManageReservation";
import EditReview from "../pages/EditReview/EditReview";
import WriteReviews from "../pages/WriteReviews/WriteReviews";
import DocumentVerification from "../pages/Document/DocumentVerification";
import CommissionFees from "../pages/CommissionFees/CommissionFees";
import AddCommissionFee from "../pages/CommissionFees/AddCommissionFee";
import Vat from "../pages/Vat/Vat";
import Percentage from "../pages/ManagedByGhorfatech/Percentage/Percentage";
import Monthly from "../pages/ManagedByGhorfatech/Monthly/Monthly";
import Otp from "../pages/ManageSms/Otp/Otp";
import PayoutDashboard from "../pages/Payouts/PayoutDashboard";
import PayoutHistory from "../pages/Payouts/PayoutHistory";
import HostPayoutDetail from "../pages/Payouts/HostPayoutDetail";
import PayoutDetail from "../pages/Payouts/PayoutDetail";
import InboxPage from "../pages/Inbox/InboxPage";

const authProtectedRoutes = [
  // Manage admin users and roles
  {
    path: "/admin-roles",
    component: <ManageAdminRoles />,
    permissions: [PERMISSIONS.MANAGE_ADMIN_ROLES],
  },
  {
    path: "/admin-users",
    component: <ManageAdminUsers />,
    permissions: [PERMISSIONS.MANAGE_ADMIN_USERS],
  },
  {
    path: "/coupons",
    component: <CouponsList />,
    permissions: [PERMISSIONS.MANAGE_COUPONS],
  },
  {
    path: "/tickets",
    component: <TicketsList />,
    permissions: [PERMISSIONS.MANAGE_TICKETS],
  },

  //chat
  {
    path: "/chat",
    component: <Chat />,
    permissions: [PERMISSIONS.MANAGE_CHAT],
  },

  // Support inbox
  {
    path: "/inbox",
    component: <InboxPage />,
    permissions: [PERMISSIONS.VIEW_USER_MESSAGES, PERMISSIONS.MANAGE_CHAT],
  },

  { path: "/dashboard", component: <Dashboard /> },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },

  // Room Type
  {
    path: "/room-type",
    component: <RoomType />,
    permissions: [PERMISSIONS.MANAGE_LISTING_SETTINGS],
  },
  {
    path: "/room-type/add",
    component: <AddRoomType />,
    permissions: [PERMISSIONS.MANAGE_LISTING_SETTINGS],
  },
  // Person Capacity
  {
    path: "/person-capacity",
    component: <PersonCapacity />,
    permissions: [PERMISSIONS.MANAGE_LISTING_SETTINGS],
  },

  // house type
  {
    path: "/house-type",
    component: <HouseType />,
    permissions: [PERMISSIONS.MANAGE_LISTING_SETTINGS],
  },
  {
    path: "/house-type/add",
    component: <AddHouseType />,
    permissions: [PERMISSIONS.MANAGE_LISTING_SETTINGS],
  },

  // Bed
  {
    path: "/bed",
    component: <Bed />,
    permissions: [PERMISSIONS.MANAGE_LISTING_SETTINGS],
  },
  // Bed type
  {
    path: "/bed-type",
    component: <BedType />,
    permissions: [PERMISSIONS.MANAGE_LISTING_SETTINGS],
  },
  {
    path: "/bed-type/add",
    component: <AddBedType />,
    permissions: [PERMISSIONS.MANAGE_LISTING_SETTINGS],
  },

  // bedroom
  {
    path: "/bedroom",
    component: <BedRoom />,
    permissions: [PERMISSIONS.MANAGE_LISTING_SETTINGS],
  },

  // bathroom
  {
    path: "/bathroom",
    component: <Bathroom />,
    permissions: [PERMISSIONS.MANAGE_LISTING_SETTINGS],
  },

  // bathroom type
  {
    path: "/bathroom-type",
    component: <BathroomType />,
    permissions: [PERMISSIONS.MANAGE_LISTING_SETTINGS],
  },
  {
    path: "/bathroom-type/add",
    component: <AddBathroomType />,
    permissions: [PERMISSIONS.MANAGE_LISTING_SETTINGS],
  },

  {
    path: "/document",
    component: <DocumentVerification />,
    permissions: [PERMISSIONS.MANAGE_USER_DOCUMENT_VERIFICATION],
  },
  // Reviews
  {
    path: "/reviews",
    component: <ReviewsManagement />,
    permissions: [
      PERMISSIONS.MANAGE_USER_REVIEWS,
      PERMISSIONS.VIEW_USER_REVIEWS,
    ],
  },
  {
    path: "/edit-review/:reviewId",
    component: <EditReview />,
    permissions: [PERMISSIONS.MANAGE_ADMIN_REVIEWS],
  },

  // safety

  {
    path: "/safety",
    component: <Safety />,
    permissions: [PERMISSIONS.MANAGE_LISTING_SETTINGS],
  },
  {
    path: "/safety/add",
    component: <AddSafety />,
    permissions: [PERMISSIONS.MANAGE_LISTING_SETTINGS],
  },

  // Space
  {
    path: "/space",
    component: <Space />,
    permissions: [PERMISSIONS.MANAGE_LISTING_SETTINGS],
  },
  {
    path: "/space/add",
    component: <AddSpace />,
    permissions: [PERMISSIONS.MANAGE_LISTING_SETTINGS],
  },

  //users
  {
    path: "/user",
    component: <User />,
    permissions: [PERMISSIONS.MANAGE_USERS, PERMISSIONS.VIEW_USERS],
  },
  {
    path: "/verify-user",
    component: <VerifyUser />,
    permissions: [PERMISSIONS.MANAGE_USERS, PERMISSIONS.VIEW_USERS],
  },
  {
    path: "/delete-requests",
    component: <DeleteRequests />,
    permissions: [PERMISSIONS.MANAGE_USERS, PERMISSIONS.VIEW_USERS],
  },
  { path: "/admin-roles", component: <ManageAdminRoles />, permissions: null },
  //profile-view
  {
    path: "/profile-view/:userId",
    component: <ProfileView />,
    permissions: [PERMISSIONS.MANAGE_USERS, PERMISSIONS.VIEW_USERS],
  },

  // site
  {
    path: "/site-settings",
    component: <SiteSettings />,
    permissions: [PERMISSIONS.MANAGE_SITE_SETTINGS],
  },

  // site configuaration
  {
    path: "/site-configurations",
    component: <SiteConfigurations />,
    permissions: [PERMISSIONS.MANAGE_CONFIGURATION_SETTINGS],
  },

  // Service Fees
  {
    path: "/service-fee",
    component: <ServiceFee />,
    permissions: [PERMISSIONS.MANAGE_SITE_SERVICE_FEE],
  },

  // Vat
  {
    path: "/vat",
    component: <Vat />,
    permissions: [PERMISSIONS.MANAGE_SITE_VAT],
  },

  // Commission Fees
  {
    path: "/commission-fees",
    component: <CommissionFees />,
    permissions: [PERMISSIONS.MANAGE_SITE_COMMISSION_FEE],
  },
  {
    path: "/commission-fee/add",
    component: <AddCommissionFee />,
    permissions: [PERMISSIONS.MANAGE_SITE_COMMISSION_FEE],
  },

  // Manage sms
  {
    path: "/manage-sms/otp",
    component: <Otp />,
    permissions: [PERMISSIONS.VIEW_OTP],
  },

  // Payouts
  {
    path: "/payouts",
    component: <PayoutDashboard />,
    permissions: [PERMISSIONS.MANAGE_PAYOUT],
  },
  {
    path: "/payouts/history",
    component: <PayoutHistory />,
    permissions: [PERMISSIONS.MANAGE_PAYOUT],
  },
  {
    path: "/payouts/host/:hostId",
    component: <HostPayoutDetail />,
    permissions: [PERMISSIONS.MANAGE_PAYOUT],
  },
  {
    path: "/payouts/detail/:payoutId",
    component: <PayoutDetail />,
    permissions: [PERMISSIONS.MANAGE_PAYOUT],
  },

  // Managed By Ghorfatech
  {
    path: "/managed-by-ghorfatech/show/percentage",
    component: <Percentage />,
    permissions: [PERMISSIONS.MANAGE_MANAGED_BY_GHORFATECH],
  },
  {
    path: "/managed-by-ghorfatech/show/monthly",
    component: <Monthly />,
    permissions: [PERMISSIONS.MANAGE_MANAGED_BY_GHORFATECH],
  },

  // Write Reviews
  {
    path: "/write-reviews",
    component: <WriteReviews />,
    permissions: [PERMISSIONS.MANAGE_ADMIN_REVIEWS],
  },

  // essential amneties
  {
    path: "/essential",
    component: <Essential />,
    permissions: [PERMISSIONS.MANAGE_LISTING_SETTINGS],
  },
  {
    path: "/essential/add",
    component: <AddEssential />,
    permissions: [PERMISSIONS.MANAGE_LISTING_SETTINGS],
  },

  // min nights
  {
    path: "/min-nights",
    component: <MinNights />,
    permissions: [PERMISSIONS.MANAGE_LISTING_SETTINGS],
  },
  // max nights
  {
    path: "/max-nights",
    component: <MaxNights />,
    permissions: [PERMISSIONS.MANAGE_LISTING_SETTINGS],
  },

  // house Rule
  {
    path: "/house-rules",
    component: <HouseRules />,
    permissions: [PERMISSIONS.MANAGE_LISTING_SETTINGS],
  },
  {
    path: "/house-rules/add",
    component: <AddHouseRules />,
    permissions: [PERMISSIONS.MANAGE_LISTING_SETTINGS],
  },

  // Property
  {
    path: "/property/in-progress",
    component: <InProgressProperties />,
    permissions: [PERMISSIONS.MANAGE_LISTINGS, PERMISSIONS.VIEW_LISTINGS],
  },
  {
    path: "/property",
    component: <Property />,
    permissions: [PERMISSIONS.MANAGE_LISTINGS, PERMISSIONS.VIEW_LISTINGS],
  },
  {
    path: "/property/create",
    component: <CreateMultiUnitListing />,
    permissions: [PERMISSIONS.MANAGE_LISTINGS],
  },
  {
    path: "/property/bulk-create",
    component: <BulkCreateListings />,
    permissions: [PERMISSIONS.MANAGE_LISTINGS],
  },

  // ListingsRequests
  {
    path: "/listings-requests",
    component: <ListingsRequests />,
    permissions: [
      PERMISSIONS.MANAGE_LISTINGS,
      PERMISSIONS.VIEW_LISTINGS,
      PERMISSIONS.VIEW_LISTINGS,
      PERMISSIONS.MANAGE_LISTING_REQUESTS,
    ],
  },

  // EditRequests
  {
    path: "/edit-requests",
    component: <EditRequests />,
    permissions: [
      PERMISSIONS.MANAGE_LISTINGS,
      PERMISSIONS.VIEW_LISTINGS,
      PERMISSIONS.MANAGE_LISTING_REQUESTS,
    ],
  },

  // Listing delete requests (host requested property removal)
  {
    path: "/listing-delete-requests",
    component: <ListingDeleteRequests />,
    permissions: [PERMISSIONS.MANAGE_LISTINGS, PERMISSIONS.VIEW_LISTINGS],
  },

  // Popular Location
  {
    path: "/popular-location",
    component: <Location />,
    permissions: [PERMISSIONS.MANAGE_POPULAR_LOCATIONS],
  },
  {
    path: "/popular-location/add",
    component: <AddLocation />,
    permissions: [PERMISSIONS.MANAGE_POPULAR_LOCATIONS],
  },

  // cancelation policy

  {
    path: "/cancelation-policy",
    component: <CancelationPolicy />,
    permissions: [PERMISSIONS.CANCELLATION_POLICY_MANAGEMENT],
  },
  {
    path: "/cancelation-policy/add",
    component: <AddCancelationPolicy />,
    permissions: [PERMISSIONS.CANCELLATION_POLICY_MANAGEMENT],
  },

  // banner
  {
    path: "/banner-image",
    component: <BannerImage />,
    permissions: [PERMISSIONS.MANAGE_HOME_PAGE_BANNERS],
  },

  // Reservation
  {
    path: "/reservation",
    component: <Reservation />,
    permissions: [
      PERMISSIONS.MANAGE_RESERVATIONS,
      PERMISSIONS.VIEW_RESERVATIONS,
    ],
  },
  {
    path: "/reservation/:reservationId",
    component: <ReservationView />,
    permissions: [
      PERMISSIONS.MANAGE_RESERVATIONS,
      PERMISSIONS.VIEW_RESERVATIONS,
    ],
  },
  {
    path: "/reservation/cancel/:reservationId",
    component: <ReservationCancel />,
    permissions: [
      PERMISSIONS.MANAGE_RESERVATIONS,
      PERMISSIONS.VIEW_RESERVATIONS,
    ],
  },
  {
    path: "/reservation/manage/:reservationId",
    component: <ManageReservation />,
    permissions: [
      PERMISSIONS.MANAGE_RESERVATIONS,
      PERMISSIONS.VIEW_RESERVATIONS,
    ],
  },
];

const publicRoutes = [
  { path: "/logout", component: <Logout /> },

  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
  { path: "/lock-screen", component: <AuthLockScreen /> },

  // Authentication Inner
  { path: "/auth-login", component: <Login1 /> },
  { path: "/auth-register", component: <Register1 /> },
  { path: "/auth-recoverpw", component: <ForgetPwd1 /> },

  { path: "/maintenance", component: <Maintenance /> },
  { path: "/comingsoon", component: <CommingSoon /> },
  { path: "/404", component: <Error404 /> },
  { path: "/500", component: <Error500 /> },
  { path: "*", component: <Error404 /> },
];

export { authProtectedRoutes, publicRoutes };
